import { FormOption } from 'types';

export const refuseReasons: FormOption[] = [
  { label: 'Desconto/ Parc. Não Permitida', value: 'DISCOUNT_ABOVE_ALLOWABLE' },
  { label: 'Produto Com Defeito/ WFA', value: 'DEFECTIVE_PRODUCT' },
  { label: 'Produto De Troca', value: 'EXCHANGE_PRODUCT' },
  { label: 'Produto Reservado', value: 'RESERVED_PRODUCT' },
  { label: 'Produto Sem Estoque', value: 'STOCK_DIVERGENCE' },
  { label: 'Produto em Malinha', value: 'CONSIGNMENT_SELLING' },
  { label: 'Produto em Transferência/ Remanejo', value: 'PRODUCT_TRANSFER' },
  { label: 'Marketing/ Seeding', value: 'MARKETING_SEEDING' },
  { label: 'Voucher Não Aceito', value: 'VOUCHER_NOT_ACCEPTED' },
  { label: 'Tempo Expirado', value: 'DEADLINE_EXCEEDED' },
];

export const refuseReasonsOptions: FormOption[] = refuseReasons.filter(
  ({ value }) => value !== 'DEADLINE_EXCEEDED'
);

export const ACTION: { [key: string]: string } = {
  DEADLINE_EXCEEDED: 'Tempo Expirado',
  CONFIRMED_BY_STORE: 'Aceitou',
};

export const REFUSAL: { [key: string]: string } = refuseReasons.reduce(
  (acumulator, currentRefuse) => ({
    ...acumulator,
    [currentRefuse.value]: `Negou - ${currentRefuse.label}`,
  }),
  {}
);

export const PERFORMANCE_ACTION = {
  ...ACTION,
  ...REFUSAL,
};
